import React from "react";
import Swiper from "react-id-swiper";
import "./carousel.scss";

const Carousel = ({ children, key, images, slidesPerView, activeSlideKey, pagination, paginationTitle, paginationPrefix, autoheight, autoplay, navigation }) => {
    const params = {
        activeSlideKey: activeSlideKey ? activeSlideKey : null,
        direction: 'horizontal',
        mousewheelControl: true,
        slidesPerView: slidesPerView,

        autoHeight: autoheight ? autoheight : false,
        // centeredSlides: !vertical ? true : false,
        spaceBetween: 0,
        lazy: true,
        loop: true,
        autoplay: autoplay && {
            delay: 5000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: pagination ?
                (index, className) => {
                    const _paginationPrefix = paginationPrefix && index == 0 ? paginationPrefix + ' ' : '';
                    if (paginationTitle) {
                        return '<div class="' + className + ' tooltip top" data-tooltip="' + paginationTitle[index] + '"><span>' + (index + 1) + '</span></div>';
                    } else {
                        return '<div class="' + className + '">' + _paginationPrefix + '<span>' + (index + 1) + '</span></div>';
                    }
                } : ''
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        renderPrevButton: () =>
            navigation && <button className = "swiper-button-prev" >&nbsp; </button>,
        renderNextButton: () =>
            navigation  && <button className = "swiper-button-next" >&nbsp; </button>,
    };
    return (
      <Swiper {...params } key = { key } >
        {
            images && images.length > 0 ?
            images.map((item, index) => (
            <img
              className = "responsive-image"
                src = { item }
                alt = "" />
            )) : children
        }
        </Swiper>
    );
};
export default Carousel;